export default __webpack_public_path__ + "static/media/amex.fb84fc42.svg";